<script>
export default {
  name: 'NonDynamicTransportTripSeatingsRow',
  props: {
    index: {
      type: Number,
      required: true,
    },
    tripSeating: {
      type: Object,
      required: true,
    },
    seatingSectionTypes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      wholePlaneSelector: false,
      optionalSelector: false,
      freeSelector: false,
      showCommentModal: false,
      localTripSeating: null,
    };
  },
  created() {
    if (this.tripSeating.id) {
      if (!this.tripSeating.price) {
        this.freeSelector = true;
      }
      if (!this.tripSeating.toRow && !this.tripSeating.fromRow) {
        this.wholePlaneSelector = true;
      }
    }
  },
  methods: {
    update(attribute, value) {
      this.$emit('update', { index: this.index, attribute, value });
    },
    updateTripSeatingSectionId(event) {
      this.update('transportSeatingSectionId', event.id);
    },
    updateTripSeatingOptional(event) {
      return event ? this.update('optional', event) : this.update('optional', false);
    },
    updateTripSeatingFromRow(event) {
      return event.length ? this.update('fromRow', +event) : this.update('fromRow', null);
    },
    updateTripSeatingToRow(event) {
      return event.length ? this.update('toRow', +event) : this.update('toRow', null);
    },
    updateTripSeatingPrice(event) {
      return event.length ? this.update('price', +event) : this.update('price', null);
    },
    updateTripSeatingComment(event) {
      return event.length ? this.update('comment', event) : this.update('comment', null);
    },
    setPriceFree(event) {
      if (event) {
        this.update('price', null);
      }
    },
  },
};
</script>

<template>
  <v-layout row>
    <v-flex xs4>
      <v-select
        class="mr-2"
        :items="seatingSectionTypes"
        :value="tripSeating.transportSeatingSectionId"
        item-text="name"
        item-value="id"
        return-object
        solo
        @change="updateTripSeatingSectionId"
      />
    </v-flex>
    <v-flex>
      <v-checkbox
        class="mt-2"
        v-model="wholePlaneSelector"
        label="Whole plane"
      />
    </v-flex>
    <v-flex>
      <v-checkbox
        class="mt-2"
        :input-value="tripSeating.optional"
        label="Optional"
        @change="updateTripSeatingOptional"
      />
    </v-flex>
    <v-flex>
      <v-checkbox
        class="mt-2"
        v-model="freeSelector"
        label="Free"
        @change="setPriceFree"
      />
    </v-flex>
    <v-flex xs1>
      <v-text-field
        class="mr-2"
        :value="tripSeating.fromRow"
        :disabled="wholePlaneSelector"
        label="From row"
        solo
        @input="updateTripSeatingFromRow"
      />
    </v-flex>
    <v-flex xs1>
      <v-text-field
        class="mr-2"
        :value="tripSeating.toRow"
        :disabled="wholePlaneSelector"
        label="To row"
        solo
        @input="updateTripSeatingToRow"
      />
    </v-flex>
    <v-flex xs1>
      <v-text-field
        class="mr-2"
        :value="tripSeating.price"
        label="Price"
        :disabled="freeSelector"
        solo
        @input="updateTripSeatingPrice"
      />
    </v-flex>
    <v-flex>
      <v-dialog
        v-model="showCommentModal"
        max-width="300"
        persistent
      >
        <template v-slot:activator="{ on }">
          <v-btn
            class="mb-4 table-icon"
            v-on="on"
            fab
            small
            color="primary"
          >
            <v-icon v-on="on" size="20" dark>info</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('nonDynamicTransport.labels.information') }}</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              :value="tripSeating.comment"
              :label="$t('nonDynamicTransport.labels.comment')"
              solo
              @input="updateTripSeatingComment"
            />
          </v-card-text>
          <v-divider class="mr-2 ml-2"/>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="success"
              @click="showCommentModal = false"
            >
              {{ $t('buttons.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
    <v-flex xs1>
      <v-icon
        class="mt-2"
        color="green darken-2"
        size="35"
        @click="$emit('add')"
      >
        add_box
      </v-icon>
      <v-icon
        color="red accent-4"
        size="35"
        @click="$emit('remove', index)"
      >
        delete
      </v-icon>
    </v-flex>
  </v-layout>
</template>

<style lang="scss" scoped>
  @import '../../assets/scss/variables';

  /deep/ .v-text-field .v-label {
    font-size: $font-size-md - 2px;
  }

  /deep/ .v-text-field {
    font-size: $font-size-md - 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportTripSeatingsRow.vue